// import axios, { AxiosRequestConfig } from 'axios';
// import qs from 'qs';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { AddressDto, AddressListResultDao, SiteAddressViewDto } from 'src/models/address';
import { GetAxiosInstance } from '../../baseService';
import { ServiceLocation } from '../../serviceLocationsAxios';

// Get Address Lookup Find
export const getAddressLookupFind = async (text: string, companyID: string, countryCode = '') => {
  return GetAxiosInstance().get<AddressListResultDao>(
    ServiceLocation.addressService +
      `/AddressLookupFind?searchText=${text}&companyID=${companyID}&countryCode=${countryCode}`
  );
};

// Get Address Lookup Retrieve
export const getAddressLookupRetrieve = async (text: string, countryCode = '') => {
  return GetAxiosInstance().get<AddressDto>(
    `${ServiceLocation.addressService}/AddressLookupRetrieve?${text}&countryCode=${countryCode}`
  );
};

export const getSiteAddresses = async (companyID: string, activeOnly = false) => {
  return GetAxiosInstance().get<SiteAddressViewDto[]>(
    ServiceLocation.addressService +
      `/SiteAddress?filter=CompanyID eq guid'${companyID}'${activeOnly ? ' and SiteStatus eq "Active"' : ''}`
  );
};
